import { Box, HStack, Spinner, type StackProps, chakra } from '@vesyl/ui/chakra'
import type { ReactNode } from 'react'
import { LuArrowLeft } from 'react-icons/lu'
import { useNavigate } from 'react-router'

type RootProps = {
  children: ReactNode
}

function Root({ children }: RootProps) {
  return (
    <HStack
      px={{ base: 4, md: 6 }}
      pt={{ base: 2.5, md: 3.5 }}
      justifyContent="space-between"
      width="full"
      minH="14"
    >
      {children}
    </HStack>
  )
}

type TitleProps = {
  children: ReactNode
  loading?: boolean
}

function Title({ children, loading }: TitleProps) {
  return (
    <Box fontSize="lg" fontWeight="medium" display="flex" alignItems="center">
      {children}
      {loading && <Spinner size="sm" ml="2" colorPalette="gray" />}
    </Box>
  )
}

function Back(props: { onClick?: () => void }) {
  const navigate = useNavigate()

  const { onClick = () => navigate(-1) } = props

  return (
    <chakra.button
      transition="all 0.2s ease-in-out"
      color="fg.muted"
      _hover={{
        transform: 'translateX(-4px)',
        color: 'fg',
      }}
      cursor="pointer"
      type="button"
      onClick={onClick}
    >
      <LuArrowLeft size={18} />
    </chakra.button>
  )
}

type LeftProps = {
  children: ReactNode
} & StackProps

function Left({ children, ...rest }: LeftProps) {
  return (
    <HStack gap="3" {...rest}>
      {children}
    </HStack>
  )
}

type RightProps = {
  children: ReactNode
} & StackProps

function Right({ children, ...rest }: RightProps) {
  return (
    <HStack gap="3" {...rest}>
      {children}
    </HStack>
  )
}

export const Header = {
  Root,
  Title,
  Left,
  Right,
  Back,
}
